<template>
  <div v-if="care_vital_sign.care_has_vital_signs.length > 0">
    <p
      :class="[
        'm-0 text-thirteen upper-text',
        item.description == 'POUCA DIURESE' && 'color-orange',
        item.description == 'DIURESE PRESENTE' && 'color-green',
        item.description == 'AUSÊNCIA DE DIURESE' && 'color-red',
      ]"
    >
      {{ item.description }}
    </p>
    <p class="mb-1 worksansr text-twelve upper-text">
      CADASTRADO POR: {{ item.user_name }}
    </p>
    <hr />
  </div>
</template>

<script>
export default {
  name: "Diurese",
  props: {
    care_vital_sign: Object,
    item: Object,
  },
};
</script>